import styled from '@emotion/styled';
import {
    colors,
    colorVariables,
    fontSizes,
    fontWeights,
    gutterSizes,
    zIndexes,
} from '@gumtree/ui-library/src/base/theme';

export const MultiSelectAccordionContainer = styled.div<{ isOpen: boolean }>`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: ${zIndexes.highest};
    background-color: ${colors.white};
    transform: ${({ isOpen }) => (isOpen ? 'translateX(0)' : 'translateX(100%)')};
    transition: transform 0.3s ease-in-out;
    overflow-y: auto;
    overflow-x: hidden;
`;

export const MultiSelectAccordionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: ${gutterSizes.large};
    border-bottom: 1px solid ${colors.bark20};
    position: sticky;
    top: 0;
    left: 0;
    font-size: ${fontSizes.base};
    font-style: normal;
    font-weight: ${fontWeights.bold};
    background-color: ${colors.white};
`;

export const IconContainer = styled.div`
    width: 56px;
    height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const ClearAll = styled.div`
    color: ${colorVariables.textHighlightedDescription};
    text-align: center;
    font-size: ${fontSizes.small};
    font-weight: 330;
    line-height: 20px;
    letter-spacing: 0.13px;
`;

export const MenuList = styled.ul`
    list-style: none;
`;
